<template>
    <div class="step row no-padding">
        <div class="col-md-6">
            <div class="form-group">
                <select id="rating" name="rating" v-model="rating">
                    <option v-for="option in options" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
                <span class="select-arrow">&#9660;</span>
            </div>
        </div>
        <div class="col-md-6">
            <div class="help">
                {{ help[type][rating] }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Condition",

        data: function() {
            return {
                rating: 'good',

                options: [
                    {value: 'bad', text: 'Neobyvatelný'},
                    {value: 'nothing_much', text: 'Před rekonstrukcí'},
                    {value: 'good', text: 'Průměrný'},
                    {value: 'very_good', text: 'Po kompletní rekonstrukci'},
                    {value: 'new', text: 'Novostavba'},
                    {value: 'excellent', text: 'Luxusní'},
                ],

                help: {
                    flat: {
                        bad: 'Byt, ve kterém bez kompletní rekonstrukce není možné bydlet. Chybí koupelna i kuchyň.',
                        nothing_much: 'Je zde možné bydlet, ale koupelna i kuchyň jsou min. 25 let staré a zasloužily by si modernizaci. Jedná se např. o panelové byty s umakartovým jádrem.',
                        good: 'Kuchyň i koupelna jsou ve stavu, že je možné je bez větších úprav plně využívat. Nejsou však po kompletní rekonstrukci v posledních letech.',
                        very_good: 'Byt je kompletní rekonstrukci (kuchyň, koupelna, okna).',
                        new: 'Běžná novostavba nebo téměř nová nemovitost. Cena by měla být podobná ostatním novostavbám v okolí.',
                        excellent: 'Jsou použity velmi drahé technologie a materiály. Cena by měla být mnohem vyšší než u běžných novostaveb v okolí.'
                    },

                    house: {
                        bad: 'Dům je určený k demolici nebo kompletní rekonstrukci (střecha, okna, fasáda, kuchyň, koupelna).',
                        nothing_much: 'Nejméně 25 let zde neproběhla žádná rekonstrukce. Modernizaci si zaslouží interiér i exteriér.',
                        good: 'Dům lze pohodlně využívat. Interiér nebo exteriér však v posledních letech neprošel žádnou rekonstrukcí.',
                        very_good: 'Dům je po kompletní rekonstrukci (střecha, okna, fasáda, kuchyň, koupelna).',
                        new: 'Běžná novostavba nebo téměř nová nemovitost. Cena by měla být podobná ostatním novostavbám v okolí.',
                        excellent: 'Jsou použity velmi drahé technologie a materiály. Cena by měla být mnohem vyšší než u běžných novostaveb v okolí.'
                    },
                },
            }
        },

        computed: {
            type: function () {
                let type = this.$parent.getType();
                if (type == "cottage") {
                    type = "house";
                }

                return type;
            },

            required: function () {
                return true;
            }
        },
    }
</script>

<style scoped>
    .help {
        max-width: 320px;
        color: #9d9d9d;
        font-size: 13px;
        margin: 0 auto;
    }

    .form-group select {
        text-align: left !important;
    }

    @media(max-width: 767px) {
        .form-group select {
            max-width: none;
            width: 100% ;
        }
    }
</style>